import React from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@material-ui/core';

import styles from './DrawerContent.css';


const DrawerContent = ({ children, classes, onClose, opened, side }) => (
  <Drawer
    ModalProps={{ disableEnforceFocus: true }}
    anchor={side}
    classes={{ paper: styles[classes] || styles.default }}
    open={opened}
    width={280}
    onClose={onClose}
  >
    {children}
  </Drawer>
);

DrawerContent.propTypes = {
  children: PropTypes.node.isRequired,
  side: PropTypes.string.isRequired,
  classes: PropTypes.string,
  opened: PropTypes.bool,
  onClose: PropTypes.func,
};

DrawerContent.defaultProps = {
  classes: undefined,
  opened: undefined,
  onClose: undefined,
};

export default DrawerContent;
